import { useState, useContext, useMemo } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { HotelContext } from "../../context/hotel";
import { VideoPlayer } from "../Icons";
const ButtonVideoModal = ({ urlVideo, textButton, titleModal}) => {

    const [show, setShow] = useState(false);
    const { data } = useContext(HotelContext);

    const handleOpenModal = () => {
        setShow(true);
    }
    const handleCloseModal = () => {
        setShow(false);
    }    
    const getVideoEmbedUrl = (url) => {
        let videoId;
        if (url.includes('youtube.com') || url.includes('youtu.be')) {

            const urlParams = new URLSearchParams(new URL(url).search);
            videoId = urlParams.get('v') || url.split('v=')[1]?.split('&')[0] || url.split('youtu.be/')[1]?.split('?')[0];
            return `https://www.youtube.com/embed/${videoId}`;
        } else if (url.includes('vimeo.com')) {

            videoId = url.split('vimeo.com/')[1];
            return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }
        return null;
    };


    const embedUrl = getVideoEmbedUrl(urlVideo);

    return (
        <>
            <Button variant="link" className="font-size-md" style={{ display: "flex", verticalAlign: "baseline", padding: 0, border: "none", background: "none", color:"#333", textDecoration: "none" }} onClick={handleOpenModal}>
                <span className="mr-3">
                    <VideoPlayer width={60} color="#333"/>
                </span>
                <span style={{ fontSize: 14, textAlign: "left", alignSelf: "center" }}>{textButton}</span>
            </Button>
            {embedUrl && <Modal 
                show={show} 
                onHide={handleCloseModal} 
                className={`info-modal info-modal-video-access`}
                >
                    <Modal.Header>
                        {titleModal}
                        <CloseButton onClick={() => handleCloseModal()} />
                    </Modal.Header>
                <Modal.Body className="p-0">                    
                        <iframe
                            width="100%" 
                            height="100%"
                            className="embed-responsive-item"
                            style={{ background: "#000", border: "none" }}
                            src={embedUrl}
                            title="Video"
                            allow="autoplay; fullscreen"
                            allowFullScreen
                        ></iframe>
                </Modal.Body>
            </Modal>
            }
        </>
    );
}

export default ButtonVideoModal;
